<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户昵称">
                <a-input v-model="queryParam.userNickName" allow-clear placeholder="请输入用户昵称" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userMobile" allow-clear placeholder="请输入用户手机号" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="种子名称">
                <a-input v-model="queryParam.seedName" allow-clear placeholder="请输入种子名称" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('种子仓库.是否已种植')">
                <a-select v-model="queryParam.isPlanted" allow-clear :placeholder="$t('通用.输入.请选择')">
                  <a-select-option :value="true">{{ $t('种子仓库.已种植') }}</a-select-option>
                  <a-select-option :value="false">{{ $t('种子仓库.未种植') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('种子仓库.平台确认')">
                <a-select v-model="queryParam.platformConfirmed" allow-clear :placeholder="$t('通用.输入.请选择')">
                  <a-select-option :value="1">{{ $t('种子仓库.已确认') }}</a-select-option>
                  <a-select-option :value="0">{{ $t('种子仓库.未确认') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择状态">
                  <a-select-option :value="1">正常</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" :loading="loading" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="seedImage" slot-scope="text, record">
          <img v-if="record.seedImage" :src="record.seedImage" style="width: 60px; height: 60px; object-fit: cover" alt="种子图片" />
        </span>
        <span slot="sourceType" slot-scope="text">
          {{ getSourceTypeName(text) }}
        </span>
        <span slot="isPlanted" slot-scope="text">
          <a-tag :color="text ? 'red' : 'green'">{{ text ? '已种植' : '未种植' }}</a-tag>
        </span>
        <span slot="platformConfirmed" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'orange'">{{ text === 1 ? '已确认' : '未确认' }}</a-tag>
        </span>
        <span slot="status" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '正常' : '禁用' }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)"><a-icon type="eye" />详情</a>
          <a-divider type="vertical" v-if="record.platformConfirmed !== 1" />
          <a @click="handleConfirm(record)" v-if="record.platformConfirmed !== 1"><a-icon type="check" />确认</a>
        </span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
      <detail-modal ref="detailModal" @ok="getList" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSeedWarehouse, confirmSeedWarehouse } from '@/api/cloudplant/seedWarehouse'
import { tableMixin } from '@/store/table-mixin'
import DetailModal from './modules/DetailModal'

export default {
  name: 'UserSeedWarehouse',
  mixins: [tableMixin],
  components: { DetailModal },
  data() {
    return {
      list: [], loading: false, pageSizeOptions: ['10', '20', '50', '100'], total: 0,
      queryParam: { userNickName: undefined, userMobile: undefined, seedName: undefined, status: undefined, isPlanted: undefined, platformConfirmed: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '用户昵称', dataIndex: 'userNickName', align: 'center' },
        { title: '种子名称', dataIndex: 'seedName', align: 'center' },
        { title: '种子图片', dataIndex: 'seedImage', scopedSlots: { customRender: 'seedImage' }, align: 'center', width: 100 },
        { title: '来源类型', dataIndex: 'sourceType', scopedSlots: { customRender: 'sourceType' }, align: 'center' },
        // { title: '邮寄申请ID', dataIndex: 'mailApplyId', align: 'center' },
        { title: '是否已种植', dataIndex: 'isPlanted', scopedSlots: { customRender: 'isPlanted' }, align: 'center' },
        { title: '种植土地位置', dataIndex: 'landPosition', align: 'center' },
        { title: '平台确认', dataIndex: 'platformConfirmed', scopedSlots: { customRender: 'platformConfirmed' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 100 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getSourceTypeName(type) {
      const map = { 1: '购买', 2: '盲盒赠送', 3: '邮寄' }
      return map[type] || type
    },
    getList() {
      const requestId = this._requestId = (this._requestId || 0) + 1
      this.loading = true
      return pageSeedWarehouse({ ...this.queryParam })
        .then(response => {
          if (requestId !== this._requestId) return
          this.list = response.data.records
          this.total = response.data.total
        })
        .catch(() => {})
        .finally(() => { if (requestId === this._requestId) this.loading = false })
    },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { userNickName: undefined, userMobile: undefined, seedName: undefined, status: undefined, isPlanted: undefined, platformConfirmed: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() },
    handleDetail(row) { this.$refs.detailModal.show(row) },
    handleConfirm(row) {
      this.$confirm({
        title: '确认提示',
        content: '是否确认该种子？',
        onOk: () => {
          confirmSeedWarehouse({ id: row.id }).then(() => {
            this.$message.success('确认成功')
            this.getList()
          })
        }
      })
    }
  }
}
</script>
